module.exports = __webpack_public_path__ + "static/media/Bulb_black.566e7fe3.svg";